// extracted by mini-css-extract-plugin
module.exports = {"control":"styles_control__6j8Qh","icon":"styles_icon___lai_"};